import {useRef, useState} from 'react'
import html2pdf from 'html2pdf.js'
// import moment from 'moment'

import {Button} from 'react-bootstrap'

import {IDeliveryOneDispatch} from '../../graphql/types/despachoTypes'
import {COLOR_PRIMARY} from '../../helpers/consts'
import {parseId} from '../../helpers'
import {Spinner} from '../Spinner'
import moment from 'moment'
import {useGetUser} from '../../hooks/useGetUser'

// const BG_PRIMARY = '#ff8d00'
const RADIUS = '6px'
export const ViewDispatchDelivery = ({
  delivery,
  id,
}: {
  delivery: IDeliveryOneDispatch
  id: string
}) => {
  const {user} = useGetUser()
  const divRef = useRef<HTMLDivElement>(null)
  const [loadingDown, setLoadingDown] = useState(false)

  const handleDownload = () => {
    if (!divRef.current) return
    setLoadingDown(true)
    html2pdf()
      .set({
        margin: 2,
        image: {type: 'jpeg'},
        html2canvas: {
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        filename: `Envio-${parseId(id)}.pdf`,
      })
      .from(divRef.current)
      .save()
      .then(() => {
        setLoadingDown(false)
      })
  }
  return (
    <>
      <div className='p-4' style={{overflowX: 'auto'}}>
        <div ref={divRef} style={{padding: '12px'}}>
          <div
            style={{
              minWidth: '400px',
              border: `1px solid ${COLOR_PRIMARY}`,
              borderRadius: RADIUS,
            }}
          >
            <header
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                color: COLOR_PRIMARY,
                padding: '10px',
              }}
            >
              <div>
                <h1 style={{fontSize: '26px', fontWeight: 'bolder'}}>INGENIERÍA JEISAT S.A.S.</h1>
              </div>
              <div>
                <div style={{position: 'relative'}}>
                  <img
                    src='/media/jeisat/logo.png'
                    alt='Logo jeisat'
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxWidth: '290px',
                    }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      fontSize: '8px',
                      bottom: '-6px',
                      right: '0%',
                      left: '108px',
                    }}
                  >
                    NIT. 900.947.196 - 4 REGIMEN COMUN
                  </span>
                </div>
              </div>
            </header>

            <main
              style={{
                marginTop: '5px',
                minHeight: '385px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderTop: `1px solid ${COLOR_PRIMARY}`,
                  flex: 1,
                  justifyContent: 'space-between',
                  padding: '0 30px',
                }}
              >
                <div>
                  <h3 style={{marginBottom: 0}}>COMPROBANTE TRANSPORTE TERRESTRE N°</h3>
                </div>
                <div>
                  <span style={{color: 'red', fontWeight: 'bolder', fontSize: '30px'}}>
                    {parseId(id)}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderTop: `1px solid ${COLOR_PRIMARY}`,
                  flex: 1,
                  justifyContent: 'space-between',
                  padding: '2px 30px',
                  gap: '25px',
                }}
              >
                <div style={{display: 'flex', justifyContent: 'space-between', flex: 1}}>
                  <span style={{fontWeight: '600'}}>FECHA:</span>
                  <span style={{fontSize: '18px', fontStyle: 'italic'}}>
                    {moment().format('DD MMM [del] YYYY')}
                  </span>
                </div>
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <span style={{fontWeight: '600'}}>TOTAL RECORRIDO</span>
                  <span style={{fontSize: '18px', fontStyle: 'italic'}}>
                    {Number(delivery.totalTravel)}Km
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderTop: `1px solid ${COLOR_PRIMARY}`,
                  flex: 1,
                  justifyContent: 'space-between',
                  padding: '2px 30px',
                  gap: '25px',
                }}
              >
                <div style={{display: 'flex', justifyContent: 'space-between', flex: 1}}>
                  <span style={{fontWeight: '600'}}>DESDE:</span>
                  <span style={{fontSize: '18px', fontStyle: 'italic'}}>
                    {delivery.fromLocation}
                  </span>
                </div>
                <div style={{flex: 1, display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontWeight: '600'}}>HASTA:</span>
                  <span style={{fontSize: '18px', fontStyle: 'italic'}}>
                    {delivery.untilLocation}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderTop: `1px solid ${COLOR_PRIMARY}`,
                  flex: 1,
                  justifyContent: 'space-between',
                  padding: '2px 30px',
                }}
              >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '50%'}}>
                  <span style={{fontWeight: '600'}}>RESPONSABLE:</span>
                  <span style={{fontSize: '18px', fontStyle: 'italic'}}>
                    {delivery.responsible}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderTop: `1px solid ${COLOR_PRIMARY}`,
                  flex: 1,
                  justifyContent: 'space-between',
                  padding: '2px 30px',
                }}
              >
                <div style={{fontWeight: '600'}}>FIRMA RECIBIDO:</div>
                <div></div>
              </div>
            </main>
          </div>
        </div>
      </div>
      {Boolean(user?.tokenAuth.settings.ENVELOPE) && (
        <div className='mt-4 w-100 d-flex align-items-center justify-content-end'>
          <Button
            variant='dark'
            className='d-flex align-items-center gap-2'
            onClick={handleDownload}
            disabled={loadingDown}
          >
            {loadingDown ? (
              <Spinner size='12px' color='light' />
            ) : (
              <i className='bi bi-download text-light' />
            )}
            Descargar
          </Button>
        </div>
      )}
    </>
  )
}
